import { TYPE_CHANGE_REF_MENU } from '../constants/MenuContainerConstant'

export const actionUpdateRef = menuInstanceRef => ({
  type: TYPE_CHANGE_REF_MENU,
  menuInstanceRef
})
